export const FolderListStatusService = Symbol.for('FolderListStatusService');
